import React from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { Typography } from "@mui/material";
import clsx from "clsx";

const PREFIX = "EndAndSave";

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  title: `${PREFIX}-title`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonsContainer: `${PREFIX}-buttonsContainer`,
  marginTop: `${PREFIX}-marginTop`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: "100%",
    color: "black",
    textAlign: "center",
    padding: "1rem 0.5rem",
  },

  [`& .${classes.title}`]: {
    marginBottom: "0.5rem !important",
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up("sm")]: {
      width: "80%",
    },
    margin: "0 auto",
  },

  [`& .${classes.buttonsContainer}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    minHeight: "150px",
  },

  [`&. ${classes.marginTop}`]: {
    marginTop: "1rem !important",
  },
}));

const EndAndSave = (props) => {
  const { t } = useTranslation();

  if (props.currentStep >= 10) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.marginTop)}>
          <Typography variant="h5" className={classes.title}>
            {t("exparienceCreateForm.goToConfigTitle")}
          </Typography>
          <div className={classes.contentContainer}>
            <div className={classes.buttonsContainer}>
              <Button
                variant="contained"
                color="primary"
                disabled={!props.isValid}
                onClick={(e) => props.handleSaveAndAction("configure")}
              >
                {t("exparienceCreateForm.goToConfigSaveAndGo")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!props.isValid}
                onClick={(e) => {
                  props.handleSaveAndAction("quit");
                }}
              >
                {t("exparienceCreateForm.goToConfigSaveAndQuit")}
              </Button>
            </div>
          </div>
        </div>
      </Root>
    );
  } else {
    return null;
  }
};

export default EndAndSave;
